
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ThemeSwitcher from './hook/ThemeSwitcher';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeSwitcher />
    <App />
  </React.StrictMode>
);
reportWebVitals();


